import { Injectable } from '@angular/core';
import { Http , Response} from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { Utils } from './../shared/utils';

import 'rxjs/add/operator/toPromise';


import { Usuario } from './../usuario/usuario';

@Injectable()
export class UsuarioService {

  private usuarioUrl = '/usuarios';

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService,
    private utils: Utils
  ) { }

  getUsuarios(params?: any): Promise<Usuario[]> {

    return this.http.get(this.usuarioUrl, {search: this.utils.buildParams(params)})
                .toPromise()
                .then(response => response.json().dados as Usuario[])
                .catch((error) => this.handleError(error));
  }

  getUsuarios2(id:number): Promise<Usuario> {
    let url: string  = this.usuarioUrl + '/' + id;
    return this.http.get(url)
                .toPromise()
                .then(response => response.json().dados as Usuario)
                .catch((error) => this.handleError(error));
  }

  getUsuario(id:number): Promise<Usuario> {
    let url: string  = this.usuarioUrl + '/' + id;
    return this.http.get(url)
                .toPromise()
                .then(response => response.json().dados as Usuario)
                .catch((error) => this.handleError(error));
  }

  saveUsuario(usuario: Usuario): Promise<Response>{
    let url: string = this.usuarioUrl;

    if(usuario.id !== undefined)
      url = url + '/' + usuario.id;

    return this.http
               .post(url, this.utils.buildFormData(usuario))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  lembrarSenha(usuario: Usuario): Promise<Response>{
    let url: string = this.usuarioUrl + '/lembrar_senha';

    return this.http
               .post(url, this.utils.buildFormData(usuario))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  resetarSenha(credencial:any): Promise<Response>{
    let url: string = this.usuarioUrl + '/resetar_senha';

    return this.http
               .post(url, this.utils.buildFormData(credencial))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  private handleSuccess(resp: any): Promise<any> {
    this.utils.flashMessage(resp.msg, 'success');
    //this._flashMessagesService.show(resp.msg, { cssClass: 'card alert-success', timeout: 5000 });
    return resp;
  }

  private handleError(error: any): Promise<any> {
     switch (error.status) {
      case 500:
        this.utils.flashMessage('Ocorreu error no servidor, entre em contato com o administrador.', 'danger');
        //this._flashMessagesService.show("Ocorreu error no servidor, entre em contato com o administrador.", { cssClass: 'card alert-danger', timeout: 5000 });
        break;
      case 403:
        this.utils.flashMessage(error.json().msg, 'warning');
        //this._flashMessagesService.show(error.json().msg, { cssClass: 'card alert-warning', timeout: 5000 });
        break;
      default:
      this.utils.flashMessage("Ocorreu um error, tente novamente mais tarde.", 'danger');
        //this._flashMessagesService.show("Ocorreu um error, tente novamente mais tarde.", { cssClass: 'card alert-danger', timeout: 5000 });
    }
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/usuarios/usuarios.service.ts